import script from "./OrderView.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderView.vue?vue&type=script&setup=true&lang=js"

import "./OrderView.vue?vue&type=style&index=0&id=2831e747&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2831e747"]])

export default __exports__